import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'contact',
  templateUrl: 'contact.html',
  inputs: ['mainContactObjects']
})
export class ContactComponent implements AfterViewInit {

  mainContactObjects: any;

  constructor() {

  }

  ngAfterViewInit(): void {

  }

}



// WEBPACK FOOTER //
// ./src/components/contact/contact.ts